import { has } from 'ramda'
import { getLocalCurrency } from '../API/Billing'

export const getPriceFromMatrix = (priceMatrix = {}, fee = {}) => {
  const localCurrency = getLocalCurrency()
  return has(localCurrency, priceMatrix)
    ? { currency: localCurrency, amount: priceMatrix[localCurrency] }
    : fee
}
